// Module
var code = "<md-button class=\"show-button\" ng-click=\"$ctrl.onShowPanel($event)\"> <md-icon md-svg-icon=\"settings\" class=\"bringoz-icon-medium\"></md-icon> <md-tooltip>{{'View Settings' | translate}}</md-tooltip> </md-button> ";
// Exports
export default code;